import { IconName } from 'shared';

// OpenWeatherMap icon codes to local icon mapping
// Format: iconCode -> localIconName
export const WEATHER_ICON_MAPPING: Record<string, IconName> = {
  // Clear sky
  '01d': 'clearSkyDay', // clear sky day
  '01n': 'clearSkyNight', // clear sky night

  // Few clouds
  '02d': 'cloudsFewDay', // few clouds day
  '02n': 'cloudsFewNight', // few clouds night

  // Scattered clouds
  '03d': 'cloudsScattered', // scattered clouds
  '03n': 'cloudsScattered', // scattered clouds

  // Broken clouds
  '04d': 'cloudsBroken', // broken clouds
  '04n': 'cloudsBroken', // broken clouds

  // Shower rain
  '09d': 'rainShower', // shower rain
  '09n': 'rainShower', // shower rain

  // Rain
  '10d': 'rain', // rain day
  '10n': 'rain', // rain night

  // Thunderstorm
  '11d': 'thunderstorm', // thunderstorm day
  '11n': 'thunderstorm', // thunderstorm night

  // Snow
  '13d': 'snow', // snow day
  '13n': 'snow', // snow night

  // Mist
  '50d': 'mist', // mist
  '50n': 'mist', // mist

  // Group 2xx - Thunderstorm (all use lightning icon)
  '200': 'thunderstorm', // thunderstorm with light rain
  '201': 'thunderstorm', // thunderstorm with rain
  '202': 'thunderstorm', // thunderstorm with heavy rain
  '210': 'thunderstorm', // light thunderstorm
  '211': 'thunderstorm', // thunderstorm
  '212': 'thunderstorm', // heavy thunderstorm
  '221': 'thunderstorm', // ragged thunderstorm
  '230': 'thunderstorm', // thunderstorm with light drizzle
  '231': 'thunderstorm', // thunderstorm with drizzle
  '232': 'thunderstorm', // thunderstorm with heavy drizzle

  // Group 3xx - Drizzle (all use rain icon)
  '300': 'rain', // light intensity drizzle
  '301': 'rain', // drizzle
  '302': 'rain', // heavy intensity drizzle
  '310': 'rain', // light intensity drizzle rain
  '311': 'rain', // drizzle rain
  '312': 'rain', // heavy intensity drizzle rain
  '313': 'rain', // shower rain and drizzle
  '314': 'rain', // heavy shower rain and drizzle
  '321': 'rain', // shower drizzle

  // Group 5xx - Rain (all use rain icon)
  '500': 'rain', // light rain
  '501': 'rainShower', // moderate rain
  '502': 'rainShower', // heavy intensity rain
  '503': 'rainShower', // very heavy rain
  '504': 'rainShower', // extreme rain
  '511': 'snow', // freezing rain
  '520': 'rainShower', // light intensity shower rain
  '521': 'rainShower', // shower rain
  '522': 'rainShower', // heavy intensity shower rain
  '531': 'rainShower', // ragged shower rain

  // Group 6xx - Snow (all use snow icon)
  '600': 'snow', // light snow
  '601': 'snow', // snow
  '602': 'snow', // heavy snow
  '611': 'snow', // sleet
  '612': 'snow', // light shower sleet
  '613': 'snow', // shower sleet
  '615': 'snow', // light rain and snow
  '616': 'snow', // rain and snow
  '620': 'snow', // light shower snow
  '621': 'snow', // shower snow
  '622': 'snow', // heavy shower snow

  // Group 7xx - Atmosphere (most use fog icon, some use miscellaneous)
  '701': 'mist', // mist
  '711': 'smoke', // smoke
  '721': 'haze', // haze
  '731': 'mist', // sand/dust whirls
  '741': 'fog', // fog
  '751': 'mist', // sand
  '761': 'dust', // dust
  '762': 'mist', // volcanic ash
  '771': 'mist', // squalls
  '781': 'tornado', // tornado

  // Group 800 - Clear
  '800': 'clearSkyDay', // clear sky

  // Group 80x - Clouds (all use cloud icon)
  '801': 'cloudsFewDay', // few clouds
  '802': 'cloudsScattered', // scattered clouds
  '803': 'cloudsBroken', // broken clouds
  '804': 'cloudsBroken' // overcast clouds
};

// Fallback icon for unknown weather conditions
export const DEFAULT_WEATHER_ICON: IconName = 'miscellaneous';

/**
 * Get the local icon name for a given OpenWeatherMap icon code
 */
export function getWeatherIconName(iconCode: string): IconName {
  return WEATHER_ICON_MAPPING[iconCode] || DEFAULT_WEATHER_ICON;
}
